import * as FIELD_NAME from 'constant/form-item-names'
import * as FIELD_LABEL from 'constant/form-labels'
import * as RULES from 'constant/form-rules'
import React, { useState } from 'react'
import { Form, Input, Checkbox } from 'antd'
import PropTypes from 'prop-types'
import styles from '../styles.scss'

const QlikUrlInput = ({ required = true, qlikUrl, category }) => {
  const [visible, setVisible] = useState(!!qlikUrl)
  return (category
    ? <>
      <Form.Item
        name={FIELD_NAME.LANDING_PAGE}
        valuePropName='checked'
      >
        <Checkbox
          defaultChecked={visible}
          onChange={() => setVisible(!visible)}
        >{FIELD_LABEL.LANDING_PAGE}</Checkbox>
      </Form.Item>
      {visible &&
        getQlikInput(required)
      }

    </>
  : getQlikInput(required))
}

const getQlikInput = (required) => (
  <>
    <span>{FIELD_LABEL.QLIK_URL_INPUT}</span>
    <Form.Item
      name={FIELD_NAME.QLIK_URL}
      rules={required ? [RULES.REQUIRED] : null}
    >
      <Input
        className={styles.form_input}
        placeholder={'Qlik URL'}
      />
    </Form.Item>
  </>
)

QlikUrlInput.propTypes = {
  category: PropTypes.bool,
  qlikUrl: PropTypes.string,
  required: PropTypes.bool

}

export default QlikUrlInput
